<form>
  <mat-accordion>
    <mat-expansion-panel [expanded]="expandedFilter" (opened)="expandedFilter = true"
      (closed)="expandedFilter = false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'protocolList.filter.title' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>


      <div fxLayout="row" fxLayout.xs="column" class="flexwrap">

        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'executionList.filter.documentCode.label' | translate }}</mat-label>
            <input matInput
              name="documentCode" [(ngModel)]="filter.documentCode">
          </mat-form-field>
        </div>

        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'executionList.filter.protocolDocumentCode.label' | translate }}</mat-label>
            <input matInput
              name="documentCode" [(ngModel)]="filter.protocolDocumentCode">
          </mat-form-field>
        </div>

        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'executionList.filter.projectNo.label' | translate }}</mat-label>
            <input matInput
              name="projectNo" [(ngModel)]="filter.projectNo">
          </mat-form-field>
        </div>

        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'executionList.filter.client.label' | translate }}</mat-label>
            <mat-select #clientSelect name="idClient" [(ngModel)]="filter.idClient">
              @if (clientSelect.focused) {
                <mat-select-filter [displayMember]="'name'" [array]="clients"
                  (filteredReturn)="clientsFiltered =$event"
                  [noResultsMessage]="'common.noResults' | translate"
                [placeholder]="'common.selectFilterPlaceholder' | translate"></mat-select-filter>
              }
              @for (client of clientsFiltered; track client) {
                <mat-option [value]="client.id">
                  {{client.name}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <!-- <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
        <mat-form-field class="campoFormulario">
          <input matInput placeholder="{{ 'executionList.filter.equipment.label' | translate }}"
            name="equipment" [(ngModel)]="filter.equipment">
        </mat-form-field>
      </div>-->
    </div>

    <mat-accordion>
      <mat-expansion-panel expanded="false" class="filter-not-border">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'executionList.filter.advanced.title' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div fxLayout="row" fxLayout.xs="column" class="flexwrap">

          <!--<div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="campoFormulario">
            <input matInput
              placeholder="{{ 'executionList.filter.equipmentSerialNum.label' | translate }}"
              name="equipmentSerialNum" [(ngModel)]="filter.equipmentSerialNum">
          </mat-form-field>
        </div>

        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="campoFormulario">
            <input matInput
              placeholder="{{ 'executionList.filter.equipmentInternalId.label' | translate }}"
              name="equipmentInternalId" [(ngModel)]="filter.equipmentInternalId">
          </mat-form-field>
        </div>-->

        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'executionList.filter.projectManager.label' | translate }}</mat-label>
            <mat-select name="projectManager" [(ngModel)]="filter.projectManager">
              <mat-option [value]="null"> --- </mat-option>
              @for (item of projectManagers; track item) {
                <mat-option [value]="item.username">
                  {{item.fullName}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'executionList.filter.clientDocumentCode.label' | translate }}</mat-label>
            <input matInput
              name="clientDocumentCode" [(ngModel)]="filter.clientDocumentCode">
          </mat-form-field>
        </div>

        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolList.filter.process.label' | translate }}</mat-label>
            <mat-select name="idProcess" [(ngModel)]="filter.idProcess">
              <mat-option [value]="null"> --- </mat-option>
              @for (item of processes; track item) {
                <mat-option [value]="item.id">
                  {{ 'processType.' + item.translation | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>


        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'executionList.filter.status.label' | translate }}</mat-label>
            <mat-select name="idStatus" [(ngModel)]="filter.idStatus"
              [disabled]="isList === false">
              <mat-option [value]="null"> --- </mat-option>
              @for (item of statuses; track item) {
                <mat-option [value]="item.id">
                  {{ 'executionStatus.' + item.translation | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="datepicker">
            <mat-label>{{ 'executionList.filter.regFcStart.label' | translate }}</mat-label>
            <input matInput [matDatepicker]="regFcStartPicker" name="regFcStart"
              [ngModel]="filter.regFcStart" (blur)="saveDate('regFcStart', $event)"
              (dateChange)="saveDate('regFcStart', $event)">
            <mat-datepicker-toggle matSuffix [for]="regFcStartPicker"></mat-datepicker-toggle>
            <mat-datepicker #regFcStartPicker [calendarHeaderComponent]="customDatepickerHeader">
            </mat-datepicker>
          </mat-form-field>
        </div>

        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="datepicker">
            <mat-label>{{ 'executionList.filter.regFcEnd.label' | translate }}</mat-label>
            <input matInput [matDatepicker]="regFcEndPicker" name="regFcEnd"
              [ngModel]="filter.regFcEnd" (blur)="saveDate('regFcEnd', $event)"
              (dateChange)="saveDate('regFcEnd', $event)">
            <mat-datepicker-toggle matSuffix [for]="regFcEndPicker"></mat-datepicker-toggle>
            <mat-datepicker #regFcEndPicker [calendarHeaderComponent]="customDatepickerHeader">
            </mat-datepicker>
          </mat-form-field>
        </div>

        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="datepicker">
            <mat-label>{{ 'executionList.filter.modFcStart.label' | translate }}</mat-label>
            <input matInput [matDatepicker]="modFcStartPicker" name="modFcStart"
              [ngModel]="filter.modFcStart" (blur)="saveDate('modFcStart', $event)"
              (dateChange)="saveDate('modFcStart', $event)">
            <mat-datepicker-toggle matSuffix [for]="modFcStartPicker"></mat-datepicker-toggle>
            <mat-datepicker #modFcStartPicker [calendarHeaderComponent]="customDatepickerHeader">
            </mat-datepicker>
          </mat-form-field>
        </div>

        <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
          <mat-form-field class="datepicker">
            <mat-label>{{ 'executionList.filter.modFcEnd.label' | translate }}</mat-label>
            <input matInput [matDatepicker]="modFcEndPicker" name="modFcEnd"
              [ngModel]="filter.modFcEnd" (blur)="saveDate('modFcEnd', $event)"
              (dateChange)="saveDate('modFcEnd', $event)">
            <mat-datepicker-toggle matSuffix [for]="modFcEndPicker"></mat-datepicker-toggle>
            <mat-datepicker #modFcEndPicker [calendarHeaderComponent]="customDatepickerHeader">
            </mat-datepicker>
          </mat-form-field>
        </div>

        <!--<div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
        <mat-form-field class="campoFormulario">
          <input matInput name="equipmentMaker" [(ngModel)]="filter.equipmentMaker"
            placeholder="{{ 'executionList.filter.equipmentMaker.label' | translate }}">
        </mat-form-field>
      </div>

      <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
        <mat-form-field class="campoFormulario">
          <input matInput name="equipmentModel" [(ngModel)]="filter.equipmentModel"
            placeholder="{{ 'executionList.filter.equipmentModel.label' | translate }}">
        </mat-form-field>
      </div>

      <div fxFlex="25" fxFlex.xs="100%" fxFlex.sm="50%">
        <mat-form-field class="campoFormulario">
          <input matInput name="equipmentLocation"
            [(ngModel)]="filter.equipmentLocation"
            placeholder="{{ 'executionList.filter.equipmentLocation.label' | translate }}">
        </mat-form-field>
      </div>-->

    </div>
  </mat-expansion-panel>
</mat-accordion>

<div fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="start center">
  <button mat-raised-button (click)="doFilter()" color="primary">{{ 'button.filter' | translate
  }}</button>
  <button mat-button (click)="cleanFilter()">{{ 'button.clean' | translate }}</button>
</div>

</mat-expansion-panel>
</mat-accordion>
</form>